<div class="container">
    <mat-card>
        <timereport-add class="timereport-add-container" [sentDates]="sentDates"
                        [timereport]=timereport></timereport-add>
        <timereport-list [sentDates]="sentDates"></timereport-list>
    </mat-card>
</div>
